import { toWords } from "number-to-words";
import { formatDecimal, formatIso } from "@/utils/formatters";

export const invoiceFields = {
    soldTo: {
        getValue: (data) =>
            data?.payee?.sold_to?.toUpperCase() || "",

        width: "200px",

        fontClass: (data) =>
            (data?.payee?.sold_to?.length || 0) <= 80
                ? "text-xs break-words whitespace-normal"
                : "text-[10px] break-words whitespace-normal",

        textAlign: "left",

        baseTop: 135,
        useDynamicY: true,
    },

    tin: {
        getValue: (data) =>
            data?.payee?.tin || "",

        width: "auto",
        fontClass: "text-xs",
        textAlign: "left",
    },

    address: {
        getValue: (data) =>
            data?.payee?.address?.toUpperCase() || "",

        width: "200px",
        fontClass: "text-xs break-words whitespace-normal",
        textAlign: "left",
    },

    date: {
        getValue: (data) =>
            formatIso(data?.invoice_date),

        width: "auto",
        fontClass: "text-xs",
        textAlign: "left",
    },

    itemDescription: {
        getValue: (data) =>
            data?.invoiceItems?.[0]?.description?.toUpperCase() || "",

        width: "190px",
        fontClass: "text-xs break-words whitespace-normal leading-6",
        textAlign: "left",
    },

    amount: {
        getValue: (data) =>
            formatDecimal(data?.amount),

        width: "100px",
        fontClass: "text-xs",
        textAlign: "right",
    },

    checkNo: {
        getValue: (data) =>
            data?.Check_no || "",

        width: "auto",
        fontClass: "text-xs",
        textAlign: "left",
    },

    bank: {
        getValue: (data) =>
            data?.Bank || "",

        width: "auto",
        fontClass: "text-xs",
        textAlign: "left",
    },

    vatable: {
        getValue: (data) =>
            formatDecimal(data?.VATable_sales),

        width: "90px",
        fontClass: "text-xs",
        textAlign: "right",
    },

    vatExempt: {
        getValue: (data) =>
            formatDecimal(data?.vat_Exempt_sales),

        width: "90px",
        fontClass: "text-xs",
        textAlign: "right",
    },

    zeroRated: {
        getValue: (data) =>
            formatDecimal(data?.zero_rated_sales),

        width: "90px",
        fontClass: "text-xs",
        textAlign: "right",
    },

    vatAmount: {
        getValue: (data) =>
            formatDecimal(data?.vat_amount),

        width: "90px",
        fontClass: "text-xs",
        textAlign: "right",
    },

    totalSalesVatInclusive: {
        getValue: (data) =>
            formatDecimal(data?.total_sales_vat_inclusive),

        width: "120px",
        fontClass: "text-xs",
        textAlign: "right",
    },

    lessVat: {
        getValue: (data) =>
            formatDecimal(data?.less_vat),

        width: "120px",
        fontClass: "text-xs",
        textAlign: "right",
    },

    netOfVat: {
        getValue: (data) =>
            formatDecimal(data?.amount_net_of_vat),

        width: "120px",
        fontClass: "text-xs",
        textAlign: "right",
    },

    scPwdDiscount: {
        getValue: (data) =>
            formatDecimal(data?.less_sc_pwd_discount),

        width: "120px",
        fontClass: "text-xs",
        textAlign: "right",
    },

    withholdingTax: {
        getValue: (data) =>
            formatDecimal(data?.less_withholding_tax),

        width: "120px",
        fontClass: "text-xs",
        textAlign: "right",
    },

    totalDue: {
        getValue: (data) =>
            formatDecimal(data?.total_amount_due),

        width: "120px",
        fontClass: "text-xs font-semibold",
        textAlign: "right",
    },

    invoiceNumber: {
        getValue: (data) =>
            data?.invoice_number || "",

        width: "120px",
        fontClass: "text-[8px]",
        textAlign: "right",
    },

    amountWord: {
        getValue: (data) =>
            `${toWords(
                data?.total_amount_due || 0
            ).toUpperCase()} PESOS ONLY`,

        width: "320px",
        fontClass: "text-xs italic break-words whitespace-normal",
        textAlign: "left",
    },

    totalAmountDue: {
        getValue: (data) =>
            formatDecimal(data?.total_amount_due),

        width: "250px",
        fontClass: "text-xs italic break-words whitespace-normal",
        textAlign: "left",
    },
};